<template>
  <div class="comp-container">
    <gamblePopComp
      boxType="title"
      :title="getDict(210) /*领竞猜币*/"
      :show="true"
      @close="close"
    >
      <div class="task-list">
        <div
          class="task-item"
          v-for="(task, index) in taskList"
          :key="index + '' + task.tid"
        >
          <div class="gold"><i class="icon icon-gold-2" />{{ task.gold }}</div>
          <div class="name">{{ task.name }}</div>
          <div class="progress">
            ({{ task.progress }}/{{ task.max_progress }})
          </div>
          <div
            class="btn button-bg"
            :class="task.btnClass"
            @click="doTask(task)"
          >
            <span>{{ task.btnName }}</span>
          </div>
        </div>
      </div>
    </gamblePopComp>
    <gamblePopComp
      :show="!!gotGoldNum"
      boxType="title"
      :title="getDict(272) /*兑换*/"
      @close="gotGoldNum = 0"
    >
      <div class="got-gold-box">
        <div class="got-gold-text">
          {{ getDict(282) /*"您已获得竞猜币"*/ }}
        </div>
        <div class="got-gold-num">
          <i class="icon icon-gold-2" />
          <span class="num">{{ gotGoldNum }}</span>
        </div>
        <div class="button-bg done-btn" @click="gotGoldNum = 0">
          <span class="red-black-text">{{ getDict(274) /*确 定*/ }}</span>
        </div>
      </div>
    </gamblePopComp>
    <sharePopComp key="share" v-if="openShare" @close="openShare = false" />
  </div>
</template>

<script>
import { getDict, axios, webSocket, invokeNative } from "../../../../common";
import { mapState, mapGetters } from "vuex";
import gamblePopComp from "./../gamble-pop-comp";
import sharePopComp from "./../share-pop-comp";
import store from "@/store";

export default {
  name: "goldTask",
  props: {
    rightBtnNameList: {},
  },
  data() {
    return {
      gotGoldNum: 0,
      openShare: false,
      taskNameMap: {
        40211: {
          sort: 1,
          name: getDict(205) /* "每日登陆" */,
        },
        40212: {
          sort: 2,
          name: getDict(206) /* "每日参与战斗" */,
        },
        40213: {
          sort: 3,
          name: getDict(207) /* "每日组队参与战斗" */,
        },
        20555: {
          sort: 4,
          name: getDict(209) /* "发送分享连接" */,
          share: true,
        },
        40214: {
          sort: 5,
          name: getDict(208) /* "每日分享点击人数" */,
        },
      },
      // taskList: [
      //   ...Array(4)
      //     .fill({})
      //     .map((item, index) => {
      //       item = {
      //         tid: "t" + index,
      //         gold: 20,
      //         name: "t" + index,
      //         state: index % 3,
      //         ts: 1615359596,
      //       };
      //       return item;
      //     }),
      // ],
    };
  },
  computed: {
    ...mapState(["userData"]),
    ...mapGetters(["gambleUserInfo", "gambleTaskList"]),
    taskList() {
      return this.gambleTaskList
        .map((task) => {
          let taskObj = this.taskNameMap[task.tid];
          let btnName = [
            getDict(211) /*未完成*/,
            getDict(212) /*领取*/,
            getDict(213) /*已领取*/,
          ][task.state];
          let btnClass = ["none", "active", "disabled"][task.state];
          if (taskObj && taskObj.share) {
            if (task.state == 0) {
              btnName = getDict(215);
              btnClass = "active";
            }
          }
          return {
            ...task,
            sort: taskObj ? taskObj.sort : 0,
            btnName,
            btnClass,
            name: taskObj ? taskObj.name : "",
          };
        })
        .sort((a, b) => (a.sort > b.sort ? 1 : -1));
    },
  },
  watch: {},
  methods: {
    getDict,
    close() {
      this.$emit("close");
    },
    async doTask(task) {
      if (task.state == 1) {
        // console.log(123);
        await this.completeTask(task);
        return;
      }
      if (
        (task.state == 0 || task.state == 2) &&
        this.taskNameMap[task.tid] &&
        this.taskNameMap[task.tid].share
      ) {
        this.share();
      }
    },
    share() {
      // let data = {
      //   mode: "Guess",
      //   role_id: this.gambleUserInfo.uid,
      // };
      // let wtf = btoa(JSON.stringify(data));
      // console.log(wtf);
      // invokeNative(
      //   "OnClickShareLink",
      //   {
      //     share_text: "测试",
      //     share_image: "",
      //     share_link: `${location.protocol}//${location.host}/share-page/index.html?role_id=${this.gambleUserInfo.uid}`,
      //   },
      //   (res) => {
      //     this.shareLinkDone();
      //     // 执行成功
      //   },
      //   (res) => {
      //     //执行失败
      //   }
      // );
      this.openShare = true;

      //https://g83-game-center-test.game.netease.com/share-page/index.html
    },

    async completeTask(task) {
      let res = await serverApi.post("complete_task", {
        tid: task.tid,
      });
      // debugger;
      if (res.code == 200) {
        this.gotGoldNum = task.gold;
      } else {
        // switch (res.code) {
        //   case 40002:
        //     this.noEnoughtGold = true;
        //     break;
        //   case 40004: //时间不对
        //     this.popMessage = getDict(256) /* 當前時間無法兌換 */;
        //     break;
        //   case 40005:
        //     this.popMessage = getDict(255) /* 你已投注 */;
        // }
      }

      store.dispatch("gambleGetTaskList");
      store.dispatch("gambleGetUserInfo");
    },
  },
  components: {
    gamblePopComp,
    sharePopComp,
  },
  mounted() {},
  created() {},
};
</script>

<style lang="scss" scoped>
.red-black-text {
  position: relative;
  background-image: -webkit-linear-gradient(-104deg, #5c1413, #e04445);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.comp-container {
  width: 0;
  height: 0;
}
.task-list {
  width: 7.2rem;
  max-height: 3.2rem;
  overflow: auto;
  margin-bottom: 0.3rem;

  .task-item {
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 0.23rem;
    color: #fff;
    padding: 0.1rem 0;

    .gold {
      display: flex;
      align-items: center;
      width: 1.22rem;
      // flex:1;
      margin-right: 0.1rem;
      color: #ffe295;
      .icon {
        font-size: 1.5em;
      }
    }

    .name {
      width: 3.68rem;
      flex: 1;
      margin-right: 0.1rem;
    }
    .progress {
      width: 0.7rem;
      // flex:1;
      margin-right: 0.1rem;
    }
    .btn {
      $width: 1.3rem;
      $height: $width * (57/179);
      width: $width;
      height: $height;
      line-height: $height;
      text-align: center;
      color: #282728;
      font-weight: 600;

      //
      &.none {
        background: none;
        color: #cdcdcd;
      }
      &.active {
        span {
          position: relative;
          background-image: -webkit-linear-gradient(-104deg, #5c1413, #e04445);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
      &.disabled {
        filter: grayscale(100%);
      }
    }
  }
}

.got-gold-box {
  text-align: center;
  .got-gold-text {
    font-size: 0.3rem;
    color: #fff;
  }
  .got-gold-num {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0.1rem 0;
    font-size: 0.26rem;
    color: #eac86e;
    .icon {
      font-size: 0.5rem;
      margin: 0.2rem 0 0.1rem;
    }
  }

  .done-btn {
    height: 0.56rem;
    width: 1.78rem;
    line-height: 0.56rem;
    text-align: center;
    font-size: 0.26rem;
    font-weight: 600;
    color: #282728;
  }
}
</style>
